// External
import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import 'materialize-css/dist/css/materialize.min.css';

// Internal
import LoginPage from './pages/login';
import VehiclesPage from './pages/vehicles';
import * as Auth from './utils/auth';
import './App.css'

const RedirectComponent = (props) => {
  const isAuth = Auth.isAuthenticated();
  const pathname = isAuth ? '/vehicles' : '/login';
  const to = {
    pathname,
    state: { from: props.location }
  };

  return (
    <Redirect
      to={ to }
    />
  );
};

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      { ...rest }
      render={ props => {
        return Auth.isAuthenticated()
          ? <Component { ...props } { ...rest }/>
          : <Redirect to={ { pathname: '/login', state: { from: props.location } } }/>
      } }
    />
  );
};

const NonProtectedRoute = ({ component: Component, redirectTo, ...rest }) => {
  return (
    <Route
      { ...rest }
      render={ props => {
        return Auth.isAuthenticated()
          ? <Redirect to={ { pathname: redirectTo, state: { from: props.location } } }/>
          : <Component { ...props } { ...rest }/>
      } }
    />
  );
};

class App extends Component {
  state = {
    isLoading: false
  };

  toggleLoading = (isLoading) => {
    this.setState({ isLoading });
  };

  render() {
    return (
      <Router>
        <div>
          <Switch>
            <ProtectedRoute path='/vehicles' toggleLoading={ this.toggleLoading } component={ VehiclesPage }/>
            <NonProtectedRoute path='/login' toggleLoading={ this.toggleLoading } redirectTo='/vehicles'
                               component={ LoginPage }/>
            <Route component={ RedirectComponent }/>
          </Switch>
          { this.state.isLoading &&
          <div className='overlay-container'>
            <div className='overlay-content'>
              <div className="preloader-wrapper large active">
                <div className="spinner-layer spinner-green-only">
                  <div className="circle-clipper left">
                    <div className="circle"/>
                  </div>
                  <div className="gap-patch">
                    <div className="circle"/>
                  </div>
                  <div className="circle-clipper right">
                    <div className="circle"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js